// extracted by mini-css-extract-plugin
export default {"Ih":"Crd_Ih__lEo3T","crds":"Crd_crds__jsggL","crs":"Crd_crs__tyN2c","Ihp":"Crd_Ihp__2KC34","Heading":"Crd_Heading__zUHXA"};